import { ViewStyle } from 'react-native';
import { scale } from '@components/frame';
import { WithColor } from '@styles/colors';
import { TRACEABILITY_GRAPH_GEOMETRY, TRACEABILITY_GRAPH_NODE_CONFIG } from '@v2/pages/common/components/TraceabilityGraph/constants';
import { TraceabilityNode, TraceabilityNodeType } from '@v2/pages/common/components/TraceabilityGraph/types';

type GetCardContainerStyleParams = WithColor & {
  node: TraceabilityNode;
  boxStyle?: ViewStyle;
  pressHoverColor?: (color: string) => string;
};

// Card container style. Kept as a plain helper so the touchable's child stays a host
// <View> — TouchableElement (TouchableWithoutFeedback) injects its press handlers/ref onto
// its child via cloneElement, so a custom component there would swallow the tap.
export const getCardContainerStyle = ({ C, node, boxStyle, pressHoverColor }: GetCardContainerStyleParams): ViewStyle[] => {
  const config = TRACEABILITY_GRAPH_NODE_CONFIG[node.type] ?? TRACEABILITY_GRAPH_NODE_CONFIG[TraceabilityNodeType.SUMMARY];
  const emphasized = node.type === TraceabilityNodeType.NC_FILE;
  const background = node.disabled ? 'Background/Light/System' : pressHoverColor ? pressHoverColor('Background/Light/Field') : 'Background/Light/Field';

  return [
    boxStyle ?? {},
    {
      width: '100%',
      minHeight: scale(TRACEABILITY_GRAPH_GEOMETRY.cardMinHeight),
      borderRadius: scale(10),
      borderWidth: scale(emphasized ? 2 : 1),
      borderColor: emphasized ? C(config.accentColor) : C('Hairline/Light/No trans'),
      backgroundColor: C(background),
      padding: scale(13),
      gap: scale(8),
      opacity: node.disabled ? 0.7 : 1,
    },
  ];
};
